module.exports = ".card {\r\n  width: 90%;\r\n  margin: 2rem auto;\r\n}\r\n\r\n.table-head {\r\n  text-align: center;\r\n  font-size: 1em;\r\n\r\n}\r\n"